import styled from 'styled-components'
import { black, blue, grey, hoverBlue, lightGray, lightGrayThird, mainGray, red } from '../../assets/ui/colors';

export const Body = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderBlock = styled.div`
    display: flex;
    margin-top: 62px;
    height: 67px;
    & div {
        background: ${blue};
    }
    & .bottom-left {
        height: 45px;
        width: 33%;
        border-radius: 0 0 45px 0;
        margin-top: auto;
    }
    & .top {
        height: 22px;
        width: 34%;
        border-radius: 22px 22px 0 0;
    }
    & .bottom-right {
        height: 45px;
        width: 33%;
        border-radius: 0 0 0 45px;
        margin-top: auto;
    }
    @media (max-width: 600px) {
        display: none;
    }
`;

export const RowCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 58px;
    margin-bottom: 50px;
    padding: 0 24px;
    & svg {
        width: 320px;
        height: auto;
    }
`;

export const ClinicName = styled.div`
    max-width: 210px;
    margin-left: 23px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 1.25px;
    color: ${grey};
`;

export const Label = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: ${black};
    padding: 0 24px;
`;

export const FormValidate = styled.form`
    text-align: center;
    margin: 50px auto 0;
    padding: 0 24px;
    text-align: -webkit-center;
    text-align: -moz-center;
    max-width: 830px;
    width: 100%;
    @media (max-width: 600px) {
        max-width: calc(100vw - 48px);
    }
    & .MuiInputBase-fullWidth {
        background: #c5c6c633;
    }
    & input {
        height: 44px;
        padding: 6px 12px;
    }
    & .MuiFormControlLabel-root {
        float: left;
        margin-bottom: 26px;
    }
    & .MuiFormControl-marginNormal {
        margin: 0;
    }
    & #birthday-helper-text {
        display: none;
    }
`;

export const InputContainer = styled.div`
    /* height: 56px; */
    margin-bottom: 28px;
    max-width: 395px;
    border-bottom: ${props => props.isError ? `2px solid ${red}` : 'none'};
    & .react-tel-input {
        width: 100%;
        background: #c5c6c633;
        color: rgba(0, 0, 0, 0.87);
        cursor: text;
        display: inline-flex;
        position: relative;
        font-size: 1rem;
        box-sizing: border-box;
        align-items: center;
        font-family: Muller;
        font-weight: 400;
        line-height: 1.1876em;
        & .special-label {
            display: none;
        }
        & input {
            position: relative;
            font: inherit;
            color: currentColor;
            width: 100%;
            border: 0;
            height: 1.1876em;
            margin: 0;
            display: block;
            padding: 6px 0 7px;
            min-width: 0;
            background: none;
            box-sizing: content-box;
            animation-name: mui-auto-fill-cancel;
            letter-spacing: inherit;
            animation-duration: 10ms;
            -webkit-tap-highlight-color: transparent;
            height: 56px;
            padding: 6px 12px;
            box-sizing: border-box;
        }
        & input:focus-visible {
                outline: none;
                border-bottom: 1px solid ${hoverBlue};
            }
        & input:after {
            left: 0;
            right: 0;
            bottom: 0;
            content: "";
            position: absolute;
            transform: scaleX(0);
            transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
            border-bottom: ${props => props.isError ? `1px solid ${red}` : 'none'};
            pointer-events: none;
        }
        & input:before {
            left: 0;
            right: 0;
            bottom: 0;
            position: absolute;
            transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            pointer-events: none;
        }

    }
    .MuiFilledInput-input {
        padding: 10px 12px;
    }
    & .MuiSelect-root {
        line-height: 36px;
    }
    & .MuiInputBase-root {
        :before {
            border-bottom: none;
        }
        :after {
            border-bottom: 1px solid ${hoverBlue};
        }
        :hover {
            background: ${lightGrayThird};
        }
    }
    & .MuiInputBase-root:hover:before {
        border-bottom: none !important;
    }

    & .MuiButton-containedSecondary {
        color: white;
    }
`;

export const SuccessMessage = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: ${blue};
    margin-bottom: 12px;
`;

export const ErrorMessage = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: ${red};
    margin-bottom: 12px;
`;

export const PhoneMaskDiv = styled.div`
    display: flex;
    white-space: nowrap;
    align-items: center;
`;

export const StartPhoneNumbers = styled.div`
    margin: 0 -12px 2px 12px;
`;

export const LoadingContainer = styled.div`
    margin-left: 12px;
    display: flex;
    & svg {
        color: white;
    }
`;

export const PersDataContainer = styled.div`
    margin: -34px 5px 12px 5px;
    opacity: 0.7;
    font-size: 13px;
`;

export const LinksRow = styled.div`
    display: flex;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    color: ${black};
    & a {
        margin: 0 4px;
        & button {
            text-transform: none;
            font-size: 16px;
            : hover {
                color: ${hoverBlue};
            }
        }
    }
`;

export const InputHelperText = styled.div`
    font-size: 12px;
    color: ${mainGray};
    margin-top: -28px;
    margin-bottom: 18px;
    max-width: 395px;
    text-align: left;
`;
